import { JwtPayload } from 'jwt-decode';
import moment from 'moment-timezone';
import 'styled-components';

export { GlobalStyles } from './GlobalStyles';
export const nameof = <T>(name: keyof T) => name;

export const cloneObject = (object: any) => {
  return JSON.parse(JSON.stringify(object));
};

export const compareObjects = (object1: any, object2: any) => {
  const keys1 = Object.keys(object1);
  const keys2 = Object.keys(object2);

  if (keys1.length !== keys2.length) {
    return false;
  }

  for (let key of keys1) {
    if (object1[key] !== object2[key]) {
      return false;
    }
  }

  return true;
};

export const dateUtcOnly = (dateTime: Date, timezone?: string): Date => {
  if (!timezone && dateTime) {
    return moment(dateTime).startOf('day').utc().toDate();
  }

  return moment
    .tz(dateTime, timezone || '')
    .startOf('day')
    .utc()
    .toDate();
};

export const getAuctionBaseUrl = () => {
  if (window?._env_?.REACT_APP_AUCTION_BASE_URL) {
    return window._env_.REACT_APP_AUCTION_BASE_URL;
  }
  console.log(`development auction base url- ${import.meta.env.REACT_APP_AUCTION_BASE_URL}`);
  return import.meta.env.REACT_APP_AUCTION_BASE_URL;
};

export const getBidBaseUrl = () => {
  if (window?._env_?.REACT_APP_BID_BASE_URL) {
    return window._env_.REACT_APP_BID_BASE_URL;
  }
  console.log(`development bid base url- ${import.meta.env.REACT_APP_BID_BASE_URL}`);
  return import.meta.env.REACT_APP_BID_BASE_URL;
};

export const getBookBaseUrl = () => {
  if (window?._env_?.REACT_APP_BOOK_BASE_URL) {
    return window._env_.REACT_APP_BOOK_BASE_URL;
  }
  console.log(`development bid base url- ${import.meta.env.REACT_APP_BOOK_BASE_URL}`);
  return import.meta.env.REACT_APP_BOOK_BASE_URL;
};

export const getAuctionTimezone = () => {
  if (window?._env_?.REACT_APP_AUCTION_TIMEZONE) {
    return window._env_.REACT_APP_AUCTION_TIMEZONE;
  }
  return import.meta.env.REACT_APP_AUCTION_TIMEZONE;
};

export const getMaxBids = () => {
  if (window?._env_?.REACT_APP_MAX_NO_OF_BID_PAGES_ALLOWED) {
    return window._env_.REACT_APP_MAX_NO_OF_BID_PAGES_ALLOWED;
  }
  return import.meta.env.REACT_APP_MAX_NO_OF_BID_PAGES_ALLOWED;
};

export const getHealthCheckUrl = () => {
  const bidBaseUrl = getBidBaseUrl();
  if (!bidBaseUrl) return '/healthchecks';
  
  // Remove /api/ suffix if present since health checks are at root level
  // Also remove any trailing slash
  const baseUrl = bidBaseUrl.replace(/\/api\/?$/, '').replace(/\/$/, '');
  return `${baseUrl}/healthchecks`;
};

export interface JwtPayloadExtender extends JwtPayload {
  realm_access?: {
    roles?: string[];
  };
}
